import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Paginator } from 'primeng/primeng';





@Component({
  selector: 'app-page-index',
  // templateUrl: './page-index.component.html',
  template: `\n        <div [class]=\"styleClass\" [ngStyle]=\"style\" [ngClass]=\"'ui-paginator ui-widget ui-widget-header ui-unselectable-text'\"\n
  *ngIf=\"alwaysShow ? true : (pageLinks && pageLinks.length > 1)\">\n




  <a   class=\"ui-paginator-first ui-paginator-element ui-state-default ui-corner-all\"\n
  (click)=\"changePageToFirst($event)\" [ngClass]=\"{'ui-state-disabled':isFirstPage()}\" [tabindex]=\"isFirstPage() ? -1 : null\">\n
  <span class=\"fa fa-angle-double-left\"></span>\n
  </a>\n


  <a  class=\"ui-paginator-prev ui-paginator-element ui-state-default ui-corner-all\"\n
   (click)=\"changePageToPrev($event)\" [ngClass]=\"{'ui-state-disabled':isFirstPage()}\" [tabindex]=\"isFirstPage() ? -1 : null\">\n
    <span class=\"fa fa-angle-left\"></span>\n            </a>\n            <span class=\"ui-paginator-pages\">\n
     <a  *ngFor=\"let pageLink of pageLinks\" class=\"ui-paginator-page ui-paginator-element ui-state-default ui-corner-all\"\n
       (click)=\"changePage(pageLink - 1, $event)\" [ngClass]=\"{'ui-state-active': (pageLink-1 == getPage())}\">{{pageLink}}</a>\n            </span>\n
         <a class=\"ui-paginator-next ui-paginator-element ui-state-default ui-corner-all\"\n
          (click)=\"changePageToNext($event)\" [ngClass]=\"{'ui-state-disabled':isLastPage()}\" [tabindex]=\"isLastPage() ? -1 : null\">\n
           <span class=\"fa fa-angle-right\"></span>\n
           </a>\n

             <a  class=\"ui-paginator-last ui-paginator-element ui-state-default ui-corner-all\"\n
              (click)=\"changePageToLast($event)\" [ngClass]=\"{'ui-state-disabled':isLastPage()}\" [tabindex]=\"isLastPage() ? -1 : null\">\n
                 <span class=\"fa fa-angle-double-right\"></span>\n
                 </a>\n

                   <select class=\"ui-paginator-rpp-options ui-widget ui-state-default\" *ngIf=\"rowsPerPageOptions\" (change)=\"onRppChange($event)\">\n
                    <option *ngFor=\"let opt of rowsPerPageOptions\" [value]=\"opt\" [selected]=\"rows == opt\">{{opt}}</option>\n            </select>\n
                    </div>\n `,
  styleUrls: ['./page-index.component.scss']
})

export class PageIndexComponent extends Paginator {
  //上一页
  changePageToUp(event) {
    // console.log("上一页",event);
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/page-index/page-index.component.ts